import "./TeamPermissionsTable.scss";
import {MemberDto} from "../../generated/account-client";
import {useEffect, useState} from "react";
import {Button, Checkbox} from "antd";
import EditLocationAccessModal from "./modal/EditLocationAccessModal";
import AccountsApi from "../../api/AccountsApi";
import TeamPermissionsDropdown from "./TeamPermissionsDropdown";
import {CheckCircleFilled, CloseCircleFilled, ExclamationCircleFilled} from "@ant-design/icons";
import {CheckboxChangeEvent} from "antd/es/checkbox";

export interface TeamPermissionsTableProps {
  owner: MemberDto;
  users: MemberDto[];
  loading: boolean;
  onChangeLocationAccess: (member: MemberDto, locations: Set<string>, callback?: () => void) => void;
  onRevoke: (member: MemberDto) => void;
  onResend: (member: MemberDto) => void;
  onRemove: (member: MemberDto) => void;
}

export default function TeamPermissionsTable({
                                               owner,
                                               users,
                                               loading,
                                               onChangeLocationAccess,
                                               onResend,
                                               onRevoke,
                                               onRemove
                                             }: TeamPermissionsTableProps) {
  const [toggled, setToggled] = useState(false);
  const [editing, setEditing] = useState(false);
  const [usersCopy, setUsersCopy] = useState([] as MemberDto[]);

  const [locationModal, setLocationModal] = useState(false);
  const [selected, setSelected] = useState(null as MemberDto | null);

  useEffect(() => {
    setUsersCopy([...users]);
  }, [users])

  function savePermissions() {
    setEditing(false);

    if (owner.id) {
      AccountsApi.updatePermissions(owner.id, users).then(() => {
        setEditing(false);
      });
    }
  }

  function showLocationModal(member: MemberDto) {
    setSelected(member);
    setLocationModal(true);
  }

  function cancelEditing() {
    setUsersCopy([...users]);
    setEditing(false);
  }

  function onChangeLocationAccessDone(member: MemberDto, locations: Set<string>) {
    onChangeLocationAccess(member, locations, function () {
      setLocationModal(false)
    });
  }

  function onViewOnlyCheck(ev: CheckboxChangeEvent, member: MemberDto) {
    member.viewOnly = ev.target.checked;
    if (ev.target.checked) {
      member.templates = false;
      member.downloads = false;
    }
    setUsersCopy([...usersCopy]);
  }

  function onTemplatesCheck(ev: CheckboxChangeEvent, member: MemberDto) {
    member.templates = ev.target.checked;
    setUsersCopy([...usersCopy]);
  }

  function onDownloadsCheck(ev: CheckboxChangeEvent, member: MemberDto) {
    member.downloads = ev.target.checked;
    setUsersCopy([...usersCopy]);
  }

  return <div className={"permissions-table"}>
    <header>
      <h3 onClick={() => setToggled(!toggled)}>
        Permissions
        {!toggled && <span className={"u"}>⌃</span>}
        {toggled && <span className={"d"}>⌃</span>}
      </h3>

      {toggled && <div className={"actions"}>
        {!editing && <Button onClick={() => setEditing(true)}>Edit Permissions</Button>}
        {editing && <div>
          <Button onClick={() => cancelEditing()}>Cancel</Button>
          <Button type={"primary"} onClick={savePermissions}>Done</Button>
        </div>}
      </div>}

    </header>

    {toggled && <div className={`table ${editing ? '' : 'disabled'}`}>
      <div className={"head"}>
        <span>My Team</span>
        <span>Email</span>
        <span>Role</span>
        <span>Downloads</span>
        <span>New Templates</span>
        <span>View Only</span>
        <span>&nbsp;</span>
      </div>

      <div className={"line"}>
        <span>
          <h6><span className={"no-rp"}>{owner.name}</span></h6>
        </span>
        <span>
          <span className={"no-rp"}>{owner.email}</span>
        </span>
        <span>Owner</span>
        <span><Checkbox checked={true} disabled={true}/></span>
        <span><Checkbox checked={true} disabled={true}/></span>
        <span><Checkbox checked={true} disabled={true}/></span>
        <span>&nbsp;</span>
        <span>&nbsp;</span>
      </div>

      {usersCopy
        .filter(it => it.invitationStatus === "Active")
        .map(it => <div className={"line"}>
        <span>
          {it.invitationStatus === "Active" && <CheckCircleFilled/>}
          {it.invitationStatus === "Invited" && <ExclamationCircleFilled/>}
          {it.invitationStatus === "Revoked" && <CloseCircleFilled/>}
          <h6><span className={"no-rp"}>{it.name}</span></h6>
        </span>
          <span><span className={"no-rp"}>{it.email}</span></span>
          <span>{it.role === "Owner" ? "Owner" : "User"}</span>
          <span><Checkbox checked={it.downloads} disabled={!editing}
                          onChange={(ev) => onDownloadsCheck(ev, it)}/></span>
          <span><Checkbox checked={it.templates} disabled={!editing}
                          onChange={(ev) => onTemplatesCheck(ev, it)}/></span>
          <span><Checkbox checked={it.viewOnly} disabled={!editing}
                          onChange={(ev) => onViewOnlyCheck(ev, it)}/></span>
          <span><Button size={"small"} onClick={() => showLocationModal(it)}>View / Edit Locations</Button></span>
          <span>
            <TeamPermissionsDropdown member={it} onResend={onResend} onRevoke={onRevoke} onRemove={onRemove}/>
          </span>
        </div>)}
    </div>}

    {selected && <EditLocationAccessModal
      member={selected}
      visible={locationModal}
      loading={loading}
      onCancel={() => setLocationModal(false)}
      onChange={onChangeLocationAccessDone}
    />}
  </div>
}
